// Control functions related to chart title are handled here
// Function include
//  - Setting title for graph automatically / manually
//  - Alignment of graph title

import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
  setGenerateTitle,
  setTitleAlignment,
  setTitleSize,
} from '../../../redux/ChartPoperties/ChartPropertiesActions';
import InputPositiveNumber from '../CommonFunctions/InputPositiveNumber';
import { ChartOptionsProps, ChartOptionsStateProps } from '../CommonInterfaceForChartOptions';
import { updateCardControls } from '../../../redux/ChartPoperties/ChartControlsActions';

var titleOptions: any[] = [
  {
    type: 'Auto',
    title: 'Reset title',
    description: 'In auto mode, title is generated automatically based on fields dropped.',
  },
  {
    type: 'Manual',
    hintTitle: 'Click to Select Manual',
    title: 'Manual',
    description:
      "In manual mode, user can manually change the title (click the pencil icon and directly change the title) and it's no more dynamic with changing fields.",
  },
];

var titleAlignOptions: any[] = [
  { name: 'Left', value: 'left' },
  { name: 'Center', value: 'center' },
];

export const RenderTitleOptions: any = ({ generateTitle, setTitleOption, fromDashboard }: any) =>
  titleOptions.map((option: any) => {
    const isSelected = option.type === generateTitle;

    const handleButtonSelect = () => {
      if (fromDashboard) return;
      setTitleOption(option.type);
    };

    return (
      <div
        className={isSelected ? 'radioButtonSelected' : 'radioButton'}
        title={fromDashboard ? 'Disabled in dashboard' : option.hintTitle || option.title}
        style={{
          // backgroundColor: isSelected
          //   ? 'rgba(224, 224, 224, 1)'
          //   : fromDashboard && backgroundColor
          //     ? backgroundColor
          //     : 'white',
          fontWeight: isSelected ? '600' : 'normal',
          cursor: fromDashboard ? 'not-allowed' : 'pointer',
          opacity: fromDashboard ? 0.5 : 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '6px 10px',
          minHeight: '28px',
          flex: '1 1 0%',
        }}
        onClick={handleButtonSelect}
      >
        <span>{option.type}</span>
      </div>
    );
  });

export const RenderTitleAlignOptions: any = ({
  titleAlignment,
  changeTitleAlignment,
  fromDashboard,
}: any) =>
  titleAlignOptions.map((option: any) => {
    const isSelected = option.value === titleAlignment;
    return (
      <div
        key={option.value}
        className={isSelected ? 'radioButtonSelected' : 'radioButton'}
        onClick={() => {
          if (!fromDashboard) changeTitleAlignment(option.value);
        }}
        style={{
          // backgroundColor: isSelected
          //   ? 'rgba(224, 224, 224, 1)'
          //   : fromDashboard && backgroundColor
          //     ? backgroundColor
          //     : 'white',
          cursor: fromDashboard ? 'not-allowed' : isSelected ? 'auto' : 'pointer',
          opacity: fromDashboard ? 0.5 : 1,
          fontWeight: isSelected ? '600' : 'normal',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '6px 10px',
          minHeight: '28px',
          flex: '1 1 0%',
        }}
        title={fromDashboard ? 'Disabled in dashboard' : ''}
      >
        {option.name}
      </div>
    );
  });

interface ChartTitleProps {
  setGenerateTitleToStore: (propKey: string, option: string) => void;
  setTitleAlignment: (propKey: string, align: string) => void;
  setTitleSize: (propKey: string, value: number) => void;
  updateCardControls: (propKey: string, option: string, value: number) => void;
  fromDashboard?: boolean;
  iconColor?: string;
}
const ChartTitle = ({
  chartProperties,
  tabTileProps,
  chartControls,
  fromDashboard = false,
  setGenerateTitleToStore,
  setTitleAlignment,
  setTitleSize,
  updateCardControls,
  iconColor,
}: ChartOptionsProps & ChartTitleProps) => {
  var propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  var generateTitle: string = chartProperties.properties[propKey].titleOptions.generateTitle;
  var titleAlignment: string = chartProperties.properties[propKey].titleOptions.titleAlign;

  const selectedTitleOption = titleOptions.find((option) => option.type === generateTitle);
  const currentDescription = selectedTitleOption ? selectedTitleOption.description : null;

  const setGenerateTitle = (type: string) => {
    setGenerateTitleToStore(propKey, type);
  };

  const changeTitleAlignment = (value: string) => {
    setTitleAlignment(propKey, value);
  };

  return (
    <React.Fragment>
      {chartProperties.properties[propKey].chartType === 'simplecard' ? (
        <div className="optionsInfo"></div>
      ) : (
        <>
          <div className="optionsInfo">
            <div
              className="radioButtons"
              style={{
                marginTop: '10px',
                paddingTop: '8px',
                alignItems: 'flex-start',
              }}
            >
              <RenderTitleOptions
                generateTitle={generateTitle}
                setTitleOption={setGenerateTitle}
                fromDashboard={fromDashboard}
              />
            </div>
            {currentDescription && (
              <div className="radioButtons" style={{ marginTop: '0px' }}>
                <div
                  className="descriptionBox"
                  style={{
                    padding: '8px 10px',
                    fontSize: '12px',
                    color: fromDashboard && iconColor ? iconColor : '#333',

                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    lineHeight: '1.4',
                    width: '100%',
                  }}
                >
                  {currentDescription}
                </div>
              </div>
            )}
          </div>

          <div className="optionsInfo" style={{ paddingTop: '0' }}>
            <div
              className="optionDescription"
              style={{
                paddingTop: '0',
                marginTop: '-4px',
                color: fromDashboard && iconColor ? iconColor : '#404040',
              }}
            >
              Title Align
            </div>
            <div className="radioButtons">
              <RenderTitleAlignOptions
                titleAlignment={titleAlignment}
                changeTitleAlignment={changeTitleAlignment}
                fromDashboard={fromDashboard}
              />
            </div>
            <div
              className="optionDescription"
              style={{
                marginBottom: '2px',
                marginTop: '-4px',
                color: fromDashboard && iconColor ? iconColor : '#404040',
              }}
            >
              Title Font Size
            </div>
            <div
              style={{
                marginTop: '-10px',
                marginRight: '-0.3rem',
                marginLeft: '-0.1rem',
                width: 'auto',
              }}
            >
              <InputPositiveNumber
                value={chartProperties.properties[propKey].titleOptions.fontSize}
                updateValue={(value: number) => setTitleSize(propKey, value)}
                iconColor={iconColor}
              />
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: ChartOptionsStateProps, ownProps: any) => {
  return {
    chartProperties: state.chartProperties,
    tabTileProps: state.tabTileProps,
    chartControls: state.chartControls,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setGenerateTitleToStore: (propKey: string, option: string) =>
      dispatch(setGenerateTitle(propKey, option)),

    setTitleAlignment: (propKey: string, align: string) =>
      dispatch(setTitleAlignment(propKey, align)),

    setTitleSize: (propKey: string, value: number) => dispatch(setTitleSize(propKey, value)),

    updateCardControls: (propKey: string, option: string, value: any) =>
      dispatch(updateCardControls(propKey, option, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartTitle);
